var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#B2B2B2","d":"M64 5.586L58.414 0 32.002 26.412 5.593 0 0 5.586 26.414 32 0 58.414 5.593 64l26.409-26.412L58.414 64 64 58.414 37.589 32z"}));
}

Close.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = Close;

Close.default = Close;
